import periods from '../../../data/PeriodDuration';
import { useAnalyticsDispatchContext } from "../../../context/AnalyticsContext";
import moment from 'moment';
import AnalyticsModalDatePicker from '../../AnalyticsModal/AnalyticsModalDatePicker/AnalyticsModalDatePicker';
import NiceModal from '@ebay/nice-modal-react';
import { generateDatesBeetweenPeriod } from '../../../utils/FormatDate';


function AnalyticsTopBarAction(metrics) {

    const dispatch = useAnalyticsDispatchContext();

    const setValueDropdown = (name, value, func) => {
        dispatch({ type : 'setResultInformation', payload : { [name] : value}})
        if (name == "channel_type_id") { // si on change la valeur du type de channel : web / outbbound /inbound etc, on doit remettre a ALL la valeur du phone /channel select
            dispatch({ type : 'setResultInformation', payload : { ["channel_id"] : null}})
        }
    }

    const setValueDropdownDate = async (name, value, state) => {

        if(value == 'custom') {

            const data = await NiceModal.show('analytics-popup', { Component : AnalyticsModalDatePicker });
            var {startDate, endDate} = data[0];
            startDate = moment(startDate.getTime()).format('YYYY-MM-DD');
            endDate = moment(endDate.getTime()).format('YYYY-MM-DD');
        
            const payload = { periodChoice : 'custom', firstPeriod : { date_start : startDate, date_end : endDate } }
            state.func({value : 'custom', text : `${startDate} - ${endDate}`})
            dispatch({ type : 'setResultInformation', payload} )

            return;
        }

        const dates = generateDatesBeetweenPeriod(new Date(), periods[value])
        const payload = { [name] : value, firstPeriod : { date_start : dates.start, date_end : dates.end } }
        dispatch({ type : 'setResultInformation', payload} )
    }

    const setValueDropdownMetric = (name, value, func) => {

        var payload = {condition_id : null, redirection_id : null, categorization_id : null, metrics_id : null}

        if(value != null) {
            const [id, type] = value.split('-');
            payload = {...payload, [type] : id , metrics_id : id}

            const typesMetrics = {
                condition_id : 'conditions',
                redirection_id : 'redirections',
                categorization_id : 'categorizations'
            }
            
            
            var IndexMetricPrecise = metrics[typesMetrics[type]].findIndex(metric => metric.id == id);
            var data = metrics[typesMetrics[type]][IndexMetricPrecise];
            var max = 0;
            for(let key in data.values) {
                for(let date in data.values[key]) {
                    if(data.values[key][date] > max) {
                        max = data.values[key][date];
                    }
                    data.values[key][date] = 0;
                }
            }
            metrics[typesMetrics[type]][IndexMetricPrecise].max = max
            payload = {...payload, ...metrics}
        }
        
        dispatch({ type : 'setResultInformation', payload} )
    }

    return { setValueDropdown, setValueDropdownDate, setValueDropdownMetric}
}

export default AnalyticsTopBarAction;